import { Button, styled } from '@mui/material';

const RemoveButton = styled(Button)(({ theme }) => ({
  fontSize: theme.hhglobal.typography.body.base.fontSize,
  fontWeight: theme.hhglobal.typography.body.base.fontWeight,
  textDecoration: 'underline',
}));

export default RemoveButton;
